// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"22d2d79e","453":"c5698aee","732":"3ee8856f","977":"16eae6fa"}[chunkId] + ".chunk.js";
};